import React from 'react';
import ReactDOM from 'react-dom';
import { MemberHeader } from '../components/SubscriptionPortal/MemberHeader';
const accountNavigation = document.getElementById('accountNavigation');
let page;
let path = window.location.pathname.split("/");
switch (path[path.length - 1].toLocaleLowerCase()) {
    case "account":
    case "addresses":
        page = "account";
        break;
    case "faq":
        page = "faq";
        break;
    default:
        page = "account";
        break;
}
if (accountNavigation) {
    ReactDOM.render(React.createElement(MemberHeader, { page: page }), accountNavigation);
}
